import React from 'react'
import  './footer.css'

const Footer = () => {
  return (
    <div className="footer">
  <h3 className="text-center">Developed by Arish with ❤️</h3>
    </div>
 )
 }

export default Footer;
